import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Switch,
  HashRouter,
  Route,
} from "react-router-dom";

import Login from "./components/Login";
import Entrance from "./components/Entrance";
import Popup from "./components/common/Popup";

class App extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <HashRouter>
        <React.Fragment>
          <Popup {...this.props} />
          <Switch>
            <Route path="/Login" component={Login}></Route>
            <Route path="/" component={Entrance}></Route>
          </Switch>
        </React.Fragment>
      </HashRouter>
    );
  }
}
export default App;
